import {C240LoaderActions} from '../redux_constants/c240_loader.constant';

const InitialState = {
    editor_mode: false,
    show_banner: false,
    show_loader: false,
}

export const c240LoaderReducer = (state = InitialState, action) => {
    switch (action.type) {
        case C240LoaderActions.UPDATE_C240_EDITOR_MODE:
            return {
                ...state,
                editor_mode: action.response
            }
        
        case C240LoaderActions.UPDATE_BANNER_STATE:
            return {
                ...state,
                show_banner: action.response,
            }
        
        case C240LoaderActions.UPDATE_LOADER_STATE:
            return {
                ...state,
                show_loader: action.response,
            }    
        default:
          return state;
      }
}